import { RESOURCE, ACTIONS } from '../Config';
import { RESPONSE_HEADERS, CONTENT_TYPES, HTTP_STATUS_CODES } from '../../../../_Domain/Api/Constants';
import BaseApiService from '../../../Base/Services/BaseApiService';
import ApiResponseBase from '../../../Base/Domain/ApiResponseBase';
import RedemptionRequestSearchRequestModel from '../Models/RedemptionRequestList/Get/RedemptionRequestSearchRequestModel';
import RedemptionRequestSearchResponseModel from '../Models/RedemptionRequestList/Get/RedemptionRequestSearchResponseModel';

const API_ENDPOINT = process.env.REACT_APP_REDEMPTION_MEMBERSERVICES_API_HOST;

class RedemptionRequestSearchServicesApiService extends BaseApiService {

  constructor() {
    super(API_ENDPOINT, RESOURCE);
    this.setRequestHeaders({ [RESPONSE_HEADERS.ContentType]: CONTENT_TYPES.ApplicationJson });
  }

  /**
     * @method search
     * @type {POST}
     * @description as an admin user, search redemption requests by parameters
     * 
     * @param {RedemptionRequestSearchRequestModel} request model
     * @returns {Task} [RedemptionRequestListItemModel]
     */
  search = async (params) => this._restService.post(new RedemptionRequestSearchRequestModel(params), `${RESOURCE}${ACTIONS.Search}`).then(result => typeof result?.error !== 'undefined' ? new ApiResponseBase(result?.data) : new RedemptionRequestSearchResponseModel(result));

}

export default new RedemptionRequestSearchServicesApiService();